import { useEffect } from 'react'
import { IntegrationKey, type IResponseUserIntegration } from 'entities/Integrations'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { IntegrationListStore } from 'pages/settings/pages/integrations/store/integrationListStore'
import type { IntegrationDetailsStore } from 'pages/settings/pages/integrations/store/integrationDetailsStore'

export const useEventIntegrationConnectedSettingsList = (
  integrationListStore: IntegrationListStore
) => {
  const { websocket } = useEntitiesContext()
  const handler = (userIntegrationResponse: IResponseUserIntegration) => {
    integrationListStore.syncUserIntegration(userIntegrationResponse)
  }

  useEffect(() => websocket.on(WebsocketEvent.IntegrationConnected, handler), [])
}

export const useEventIntegrationConnectedSettingsDetails = (
  integrationDetailsStore: IntegrationDetailsStore
) => {
  const { websocket, mergeFieldStore } = useEntitiesContext()
  const handler = (userIntegrationResponse: IResponseUserIntegration) => {
    const excludedIntegrationFields = [
      IntegrationKey.slack,
      IntegrationKey.aircall,
      IntegrationKey.google,
      IntegrationKey.intercom,
      IntegrationKey.calendly,
      IntegrationKey.google_calendar,
    ] as string[]

    if (!integrationDetailsStore.integration) return
    integrationDetailsStore.integration.syncUserIntegration(userIntegrationResponse)
    if (!excludedIntegrationFields.includes(integrationDetailsStore.integration.key))
      mergeFieldStore.updateIntegrationFields(integrationDetailsStore.integration.key)

    if (
      integrationDetailsStore.integration.isConnectedSettingsAvailable &&
      integrationDetailsStore.integration.key !== IntegrationKey.salesforce
    ) {
      integrationDetailsStore.handleEventIntegrationConnect()
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.IntegrationConnected, handler), [])
}
